/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'

export interface ActivitiesContextInterface {
  activities?: any;
  selectedActivities: number[];
  selectActivity: (id: number) => void;
  removeActivity: (id: number) => void;
  setActivityAvailability: (id: number, isAvailable: boolean) => void;
  isLoading: boolean,
  isSubmitting: boolean;
  editingSelection: boolean;
}

const ActivitiesContext = React.createContext<ActivitiesContextInterface | null>(null)

export default ActivitiesContext
